import { render, staticRenderFns } from "./server-autocomplete.vue?vue&type=template&id=c4bef4f4&lang=pug&"
import script from "./server-autocomplete.vue?vue&type=script&lang=ts&"
export * from "./server-autocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports